/* PDLYTE Concept R: keeps the "Pack saving" tile in the buy box in sync with the selected pack.
   pdx.js already updates the free delivery tile ([data-pdx-unlock]) and the Save £ badge; this
   script only mirrors that badge into the tile. No pricing logic lives here. */
(() => {
  'use strict';
  const sync = (root) => {
    const badge = root.querySelector('[data-pdx-save]');
    const wrap = root.querySelector('[data-pdx-save-wrap]');
    root.querySelectorAll('[data-pdx-unlock-saving]').forEach((tile) => {
      const text = badge ? badge.textContent.trim() : '';
      const on = Boolean(text) && !(wrap && wrap.hidden);
      tile.classList.toggle('is-unlocked', on);
      const label = tile.querySelector('[data-pdx-unlock-saving-text]');
      if (label) label.textContent = on ? text : (label.dataset.idle || 'Pack saving');
      const state = tile.querySelector('[data-pdx-unlock-state]');
      if (state) state.textContent = on ? 'Unlocked' : 'Locked';
    });
  };
  const init = (scope) => {
    (scope || document).querySelectorAll('[data-pdx-product]').forEach((root) => {
      if (root.dataset.pdxR) return;
      root.dataset.pdxR = '1';
      sync(root);
      root.addEventListener('change', () => requestAnimationFrame(() => sync(root)));
      root.addEventListener('click', (e) => { if (e.target.closest('[data-pdx-purchase-toggle]')) requestAnimationFrame(() => sync(root)); });
      const badge = root.querySelector('[data-pdx-save]');
      if (badge && 'MutationObserver' in window) new MutationObserver(() => sync(root)).observe(badge, { childList: true, characterData: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
